export default __webpack_public_path__ + "static/media/hero.a73141c0.png";